<template>
  <div class="mt-4">
    <div class="product flex justify-between">
      <div class="flex self-center ml-4">
        <div class="product-image mr-6">
          <img class="w-20 h-20 object-contain" v-lazy="productImage" alt="Dr Hauschka" />
        </div>
        <div class="flex self-center">
          <span class="mr-2">{{ qty }}x</span>
          {{ title }}
        </div>
      </div>
      <div class="flex self-center">
        <div>
          {{ price === 0 ? 'free' : productPrice }}
        </div>
        <div class="flex self-center ml-4 cursor-pointer" @click="$emit('remove', id)">
          <ph-x :size="24" />
        </div>
      </div>
    </div>
    <hr class="mt-4 text-dark-grey" />
  </div>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'
import { PhX } from '@dnlsndr/vue-phosphor-icons'
import utils from '@/utils'
import { useMainStore } from '@/store/main'

export default defineComponent({
  components: {
    PhX,
  },
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    productImage: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    price: {
      type: Number,
      default: '',
    },
    qty: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      default: 'EUR',
    },
    locale: {
      type: String,
      default: 'de',
    },
  },
  setup(props) {
    const { currency, locale, price } = props

    /**
     * register store
     */
    const store = useMainStore()

    const productPrice = computed(() => utils.formatterCurrency(locale, currency).format(price))
    /**
     * @return {Language} textSnippets
     */
    const textSnippets = computed(() => store.snippets)
    return {
      productPrice,
      textSnippets,
    }
  },
})
</script>
